import D2C_Entity from './Entity'
import api from '@/api'
import objects from '@/objects'
import store from '@/store'

class D2C_Account extends D2C_Entity {
  target = 'account'
  icon = 'user circle'
  static objectType = 'entityType'
  static typeName = 'account'
  static fields = {
    // avatar: {
    //   default: '',
    //   label: 'Logo URL',
    //   path: 'avatar',
    //   placeholder: 'https://',
    //   required: true,
    //   validate(value) {
    //     return value.length ? null : 'Must be set'
    //   },
    //   creating: {},
    //   updating: {},
    // },
    email: {
      default: '',
      label: 'Contact email',
      path: 'email',
      required: true,
      tooltip: 'For avatar and important notifications',
      validate() {
        return null
      },
      creating: {},
      updating: {},
    },
    name: {
      autoselect: true,
      default: '',
      label: 'Name',
      path: 'name',
      required: true,
      validate(value) {
        if (value.length > 50) {
          return 'Invalid name'
        }
        return (value && value.length > 0) ? null : 'Must be set'
      },
      creating: {},
      updating: {},
    },
  }
  static create(props = {}) {
    return new D2C_Account({limits: {}, ...props})
  }
  get $api() {
    const headers = {Authorization: `Bearer ${this.member.token}`}
    return api.withOptions({headers})
  }
  get _member() {
    return objects.Member.create(this.member)
  }
  get _tariff() {
    return store.getters.tariffsById[this.tariff]
  }
  get _isFree() {
    return this.tariff === objects.TariffFree.tariffId
  }
  get _isActiveSubscriber() {
    return this.subscription && this.expiration && new Date(this.expiration).getTime() > Date.now()
  }
  create() {
    return api.createAccount(this.getValues('creating'))
  }
  delete() {
    return this.$api.deleteAccount()
  }
  update() {
    return this.$api.updateAccount(this.getValues('updating'))
  }
  use() {
    store.dispatch('use', this.id)
  }
  useByDefault() {
    return api.setDefaultAccount(this.id)
  }
  leave() {
    return this.$api.leaveAccount()
  }
}

export default D2C_Account
